import React, { useState } from 'react';
import MotorcycleCard from '../../carousel/motorcyclehero/MotorcycleCard';
import NameNavigation from '../../carousel/motorcyclehero/NameNavigation';
import ActionButtons from '../../carousel/motorcyclehero/ActionButtons';
import motorcycles from '../../config';

const MotorcycleHero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const passURLtoMobile = (screenId, url) => {
    const messageData = { screenId, url };

    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.passURLtoMobile
    ) {
      window.webkit.messageHandlers.passURLtoMobile.postMessage(messageData);
      console.info(`Data passed to iOS: ${JSON.stringify(messageData)}`);
    } else if (window.Android && typeof window.Android.passURLtoMobile === 'function') {
      window.Android.passURLtoMobile(JSON.stringify(messageData));
      console.info(`Data passed to Android: ${JSON.stringify(messageData)}`);
    } else {
      console.warn(`Screen ID: ${screenId}, URL: ${url} - No mobile handler available`);
    }
  };

  return (
    <div className='relative bg-black text-white overflow-hidden py-2 px-4 no-scrollbar'>
      <div className='relative z-10 flex flex-col justify-between items-center h-full max-w-4xl mx-auto'>
        <div className='w-full bg-black bg-opacity-50 py-4 rounded-lg'>
          <h3 className='font-[Guardian_Sans_XCondSemi] text-[32px] leading-[1.2] tracking-normal text-white max-w-[36rem] mb-4 sm:mb-8'>
            Motorcycle
          </h3>
        </div>
        <div />
        <div className='w-full '>
          <div>
            <MotorcycleCard
              motorcycle={motorcycles[currentIndex]}
              isActive={true}
              onSelect={() => {
                passURLtoMobile(6.02, motorcycles[currentIndex].configureUrl);
              }}
            />
          </div>
        </div>

        <div className='w-full space-y-6'>
          <NameNavigation
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
            motorcycles={motorcycles}
          />
          <ActionButtons
            configureUrl={motorcycles[currentIndex].configureUrl}
            motorcycleName={motorcycles[currentIndex].name}
            passURLtoMobile={passURLtoMobile}
          />
        </div>
      </div>
    </div>
  );
};

export default MotorcycleHero;
